import React, { ReactNode } from 'react'

export default function InfoTitle({ children }: { children: ReactNode }) {
  return <span className="text-gray-3 block text-[14px] font-medium">{children}</span>
}
